import { useCallback } from 'react';

import { FormItem } from '@aircall/tractor';
import { Select } from '@components/OldSelect';
import { SelectFieldProps } from '@components/SelectField/SelectField.decl';
import { SelectSkeletonOption } from '@components/SelectSkeleton';
import { useField } from 'react-final-form';
import { useTranslation } from 'react-i18next';

export function SelectField({
  name,
  label,
  options,
  placeholder,
  selectComponent = Select,
  onClose,
  ...selectProps
}: SelectFieldProps) {
  const SelectComponent = selectComponent;
  const { t } = useTranslation();
  const {
    input: { value, onChange, onBlur },
    meta: { error, touched },
  } = useField(name);
  const showError = error && touched;
  const onChangeHandler = useCallback(
    (selected: SelectSkeletonOption) => {
      onChange(selected.value);
    },
    [onChange]
  );
  return (
    <FormItem
      label={label}
      name={name}
      gridAutoRows='max-content'
      validationStatus={showError ? 'error' : undefined}
      helpText={showError ? t(error) : undefined}
    >
      <SelectComponent
        placeholder={placeholder}
        name={name}
        options={options}
        onChange={onChangeHandler}
        onBlur={(event) => onBlur(event)}
        onClose={onClose}
        defaultSelected={value}
        {...selectProps}
      />
    </FormItem>
  );
}
